import React from 'react';

function App() {
  return <div>Hello, World!</div>;
}

export default App;
